import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { TokenStorageService } from '@core/auth/services/token-storage.service';
import { LoginService } from '../services/login.service';
import { catchError, delay, map, Observable, of, take } from 'rxjs';

export const AuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean | UrlTree> | boolean | UrlTree => {
  const tokenStorageService = inject(TokenStorageService);
  const loginService = inject(LoginService);
  const router = inject(Router);
  const token = tokenStorageService.decodeToken();

  if (!token) {
    loginService.clearAuthState();
    return router.createUrlTree(['/login']);
  }

  if (!tokenStorageService.isTokenValid()) {
    loginService.pendingUrl = state.url;

    return loginService.refreshToken().pipe(
      take(1),
      map(() => {
        return tokenStorageService.isTokenValid() ? true : false;
      }),
      catchError(() => {
        loginService.clearAuthState();
        return of(false);
      })
    );
  }

  return true;
};
